import Vue from "vue";

export interface IBillType {
    billTypeId: number
    billTypeName: string
}

const billTypeLocaleTitleMap:{[k:number]:string} = {
    1: Vue.$trans(`包年包月`), //'包年包月',
    2: Vue.$trans(`按小时`), //'按小时',
    3: Vue.$trans(`按量付费（月峰值）`), //'按峰值月结',
    5: Vue.$trans(`按量付费（按日月结）`), //'按日月结',
    81: Vue.$trans(`按使用流量`),//'按使用流量',
    80: Vue.$trans(`按固定带宽`), //按固定带宽
    82: Vue.$trans(`按量付费`), //按量付费
    83: Vue.$trans(`地域共享带宽`), //地域共享带宽
    84: Vue.$trans(`按量付费（按小时月结）`), //按小时月结
    86: Vue.$trans(`按量付费（流量）`), //'按日用量实时付费',
    87: Vue.$trans(`按量付费`), //'按小时实时结算'
    704: Vue.$trans(`按量付费（流量月结）`),//'按量月结',
    807: Vue.$trans(`增强型95付费`), //按月增强95峰值付费(月结)
    808: Vue.$trans(`第5峰均值付费`), //'按月第5峰均值付费(月结)',
    809: Vue.$trans(`按量付费（小时用量）`), //'按小时用量实时付费(小时结)',
    810: Vue.$trans(`竞价型实例`),//'竞价型实例',
    2017: Vue.$trans(`试用`) ,//试用 前端自己定义的
}

export const getBillTypeLocaleTitleById = (billTypeId:number):string|undefined => {
    return billTypeLocaleTitleMap[billTypeId]
}


// billTypeMap(key) { //计费类型
//     var map = {
//         // 1: '包年包月',
//         // 5: '按日月结',
//         // 2: '按小时',
//         // 3: '按峰值月结',
//         // 80: '按固定带宽',
//         // 82: '按量付费'
//         '1': Vue.$trans(`包年包月`), //'包年包月',
//         '2': Vue.$trans(`按小时`), //'按小时',
//         '3': Vue.$trans(`按量付费（月峰值）`), //'按峰值月结',
//         '5': Vue.$trans(`按量付费（按日月结）`), //'按日月结',
//         '80': Vue.$trans(`按固定带宽`), //按固定带宽
//         '82': Vue.$trans(`按量付费`), //按量付费
//         '83': Vue.$trans(`地域共享带宽`), //地域共享带宽
//         '84': Vue.$trans(`按量付费（按小时月结）`), //按小时月结
//         '81': Vue.$trans(`按使用流量`),//'按使用流量',
//         '704': Vue.$trans(`按量付费（流量月结）`),//'按量月结',
//         '2017': Vue.$trans(`试用`) ,//试用 前端自己定义的
//         '87': Vue.$trans(`按量付费`), //'按小时实时结算'
//         '86': Vue.$trans(`按量付费（流量）`), //'按日用量实时付费',
//         '807': Vue.$trans(`增强型95付费`), //按月增强95峰值付费(月结)
//         '808': Vue.$trans(`第5峰均值付费`), //'按月第5峰均值付费(月结)',
//         '809': Vue.$trans(`按量付费（小时用量）`), //'按小时用量实时付费(小时结)',
//         '810': Vue.$trans(`竞价型实例`)//'竞价型实例',
//     }
//     return map[key] || key;
// }
